import { AbstractIntProperty } from './AbstractIntProperty'

export class CountryId extends AbstractIntProperty {
  KEY: string = 'countryId'
}
